import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

import {BaseComponent} from './components/base/base.component';
import {BaseModule} from './components/base/base.module';
import {PaginationComponent} from './components/pagination/pagination.component';

@NgModule({
  imports: [CommonModule, BaseModule],
  exports: [BaseComponent, PaginationComponent],
  providers: [],
})
export class TableModule {
}
